








































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as def from "@/definitions";

import { Design } from "@/model/document2/page/surface/design/design";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import RadioOn from "../resources/radioOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
      ArrowDown,
      ArrowRight,
      RadioOn
  }
})
export default class MultiplePatternColorFillNone extends Vue {
    @Prop() private design!: Design;

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend: true
    };

    multiplePatternColorFillNoneContentsOpenAnimate = false;
    multiplePatternColorFillNoneContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
            this.multiplePatternColorFillNoneContentsCloseAnimate = true;
            setTimeout(() => {
                this.multiplePatternColorFillNoneContentsCloseAnimate = false;
                this.multiplePatternColorFillNoneContentsOpenAnimate = false;
                this.openStatus.opend = false;
            }, 200);
        } else {
            this.openStatus.opend = true;
            this.multiplePatternColorFillNoneContentsOpenAnimate = true;
            setTimeout(() => {
                this.multiplePatternColorFillNoneContentsOpenAnimate = false;
            }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    private changeFillType(fillType: string) {
        var layerFillType = 0;
        if (fillType == "none") {
            layerFillType = 0;
        } else if (fillType == "solid") {
            layerFillType = 1;
        } else if (fillType == "gradient") {
            layerFillType = 2;
        }

        this.changeLayerProperty(layerFillType, "fillType", true, true);
    }

    private changeLayerProperty(value: any, propertyName: string, isFinish : boolean = false, isOnce : boolean = false) 
    {
        var layers = this.design.getSelectLayerWithoutGroup();

        for(var i = 0; i < layers.length; ++i)
        {
            var layer = layers[i];

            this.$emit("doCommand", "changeLayerProperty", {
                layer : layer,
                propertyName : propertyName,
                value : value,
                isFinish : (isFinish || isOnce) && i == layers.length - 1,
                isOnce : false
            });
        }
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
